import { getGeoData, getPageViewId } from '../selectors/selectors.js';
import tracking from '../tracking/tracking.js';

const safeFindName = (array, filter) => {
  const element = array.find(filter);
  return element === undefined ? undefined : element.name;
};

export function reportPageViewWithGeoData(pageId, geoCountry, geoState, geoCity, geoZipCode) {
  tracking.reportPageViewWithGeoData(pageId, geoCountry, geoState, geoCity, geoZipCode);
}

export function getReportPageViewWithGeoData(store) {
  let prevPageViewId = null;

  return function reporter() {
    const state = store.getState();
    const pageViewId = getPageViewId(state);
    const pageViewGeoData = getGeoData(state);

    let geoCountry;
    let geoState;
    let geoCity;
    let geoZipCode;
    if (typeof pageViewGeoData.geoHierarchy !== 'undefined') {
      geoCountry = safeFindName(pageViewGeoData.geoHierarchy, (o) => o.level === 'country');
      geoState = safeFindName(pageViewGeoData.geoHierarchy, (o) => o.level === 'region');
      geoCity = safeFindName(pageViewGeoData.geoHierarchy, (o) => o.level === 'city');
    }

    if (typeof pageViewGeoData.address !== 'undefined') {
      geoZipCode = pageViewGeoData.address.zipcode;
    }

    if (prevPageViewId !== pageViewId) {
      reportPageViewWithGeoData(pageViewId, geoCountry, geoState, geoCity, geoZipCode);
    }
    prevPageViewId = pageViewId;
  };
}
